import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiFide from '../DatiFide';
import { NavLink } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, Contesto } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';


interface IFideValutazioneListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: DatiFide.CRisAPIPagineTipi_FideValutazione;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class FideValutazioneLista extends BaseComponent<Glob.IRouteGlobaleProps, IFideValutazioneListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        if ((this.props.match.params as any).ID_FideAffidamento != undefined && (this.props.match.params as any).ID_FideAffidamento != null && (this.props.match.params as any).ID_FideAffidamento != "") {
            this.ParametriFissi["ID_FideAffidamento"] = (this.props.match.params as any).ID_FideAffidamento;
        }
        this.state = {
            Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {}
        };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si può scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);

        var M = Glob.GetMenu();
        M.Main = "Affidamento";
        M.ID_MenuMain = 24;
        M.VariabiliMenu = { ["{ID_FideAffidamento}"]: (this.props.match.params as any).ID_FideAffidamento.toString() };
        this.props.SetMenu(M);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [5], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_FideValutazione", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("ImportoAffidamento", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("TipoValutazioneEsito", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("Data", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("Utente", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: DatiFide.CRisAPIPagineTipi_FideValutazione, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={6} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr data-row="0" key={dato.ID_FideValutazione}>
                        <td className="TextCenter">
                            <NavLink className="arrow" to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FideValutazione/" + dato.ID_FideValutazione}>
                                {dato.ID_FideValutazione}
                            </NavLink>
                        </td>
                        <td data-field="ImportoAffidamento" className="TextRight">{Trad.TradParam("{1-I}", [dato.ImportoAffidamento])}</td>
                        <td data-field="TipoValutazioneEsito" className="TextLeft">{dato.TipoValutazioneEsito}</td>
                        <td data-field="Data" className="TextCenter">{Trad.TradParam("{1-D}", [dato.Data])}</td>
                        <td data-field="Utente" className="TextLeft">{dato.Utente}</td>
                        <td className="TextCenter">
                            <NavLink className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FideValutazione/" + dato.ID_FideValutazione}>
                                <i className="la la-edit"></i>
                            </NavLink>
                        </td>
                    </tr>
                )}
            </tbody >;
        }
        //<div className="divtabella"><ChiamaAPI URL="/api/ControlloLimiti" /></div>
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={6}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        if (!this.ControlloAutorizzazione("FideValutazioneController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        let infoContesto: Dati.InfoContesto[] = [];
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag));
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Affidamento"), "/api/FideAffidamento/Contesto?ID_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento, "/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento));
        return <div>
            <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-tachometer-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("Valutazione")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                                <NavLink to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FideValutazione/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_FideValutazione"] || ""} name="ParametriUtente[ID_FideValutazione]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Utente")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo Campo="ParametriUtente[ID_Utente]" ID_ChiaveString={this.state.ParametriUtente["ID_Utente"] || ""} OnAggiorna={this.OnChange} URL="/api/Utenti/ListaUtenti" />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Esito")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo IgnoraPermessi Campo="ParametriUtente[ID_TipoValutazioneEsito]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoValutazioneEsito"] || ""} OnAggiorna={this.OnChange} Dati={this.state.Dati != undefined ? this.state.Dati.Tipi["TipiFideValutazioneEsito"] : undefined} />
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--center">
                                    <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
                <div>
                    <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                        <thead>
                            <tr className="sfondoTab">
                                <th data-field="ID_FideValutazione" className="TextCenter">{Trad.Trad("ID")}</th>
                                <th data-field="ImportoAffidamento" className="TextRight">{Trad.Trad("Importo affidamento")}</th>
                                <th data-field="TipoValutazioneEsito" className="TextLeft"> {Trad.Trad("Esito")}</th>
                                <th data-field="Data" className="TextCenter"> {Trad.Trad("Data")}</th>
                                <th data-field="Utente" className="TextLeft"> {Trad.Trad("Utente")}</th>
                                <th data-field="edit" className="TextCenter">{Trad.Trad("Modifica")}</th>
                            </tr>
                        </thead>
                        <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/fidevalutazione/ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                    </table>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/FideValutazioneLista.tsx